<template>
    <div>
        <div v-if="options_loaded && passed_filter && panel_required">
            <div class="designeroption" data-designer-component-id="slab_edge_colour">
                <h3 v-if="maintitle != ''">
                    {{ maintitle }}
                </h3>
                <div class="stylesoption">
                    <div class="form-group" :class="[!valid_selection ? 'has-error' : '']">
                        <label :for="'question--' + component_id">{{ title }}</label>
                        <select :id="'question--' + component_id" class="form-control" v-model="localTarget" v-if="!loading">
                            <option v-for="option in filtered_option_list" :value="option.value">{{ option.label }}</option>
                        </select>
                        <select :id="'question--' + component_id" disabled class="form-control" v-if="loading">
                            <option>Loading Options...</option>
                        </select>
                    </div>
                    <div class="p-3" v-if="extra_text != ''">
                        {{ extra_text }}
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script type="text/ecmascript-6">
    import Question from "./mixin/Question.vue";

    export default {
        mixins: [
            Question,
        ],
        props: {
            title: {
                default(){
                    return '';
                }
            },
            component_id: {
                default(){
                    return 'slab_edge_colour';
                }
            },
            colourInternal: {
                required: true,
            },
            colourExternal: {
                required: true,
            },
            hardwareLock: {
                required: true
            },
            profile: {
                required: true
            },
            slab: {
                required: true
            },
            doorRange: {
                required: false,
                default() {
                    return '';
                }
            },
            openingDirection: {
                required: false,
                default() {
                    return null;
                }
            },
            extra_text: {
                required: false,
                default() {
                    return '';
                }
            }
        },
        computed: {
            passed_filter(){
                return this.variable_ready(this.colourExternal, this.colourInternal, this.hardwareLock, this.profile, this.slab);
            },
            url(){
                return '/api/options/' + this.fabricator + '/slab-edge-colour?colour_external=' + this.colourExternal + '&colour_internal=' + this.colourInternal + '&hardware_lock=' + this.hardwareLock + '&profile=' + this.profile + '&slab=' + this.slab + '&opening_direction=' + this.openingDirection;
            },
            cache_key(){
                return '_' + this.fabricator + '_' + this.colourExternal + '_' + this.colourInternal + '_' + this.hardwareLock + '_' + this.profile + '_' + this.slab + '_' + this.openingDirection;
            },
        },
        watch: {
            'colourExternal': function (val, oldVal) {
                this.update_options();
            },
            'colourInternal': function (val, oldVal) {
                this.update_options();
            },
            'hardwareLock': function (val, oldVal) {
                this.update_options();
            },
            'profile': function (val, oldVal) {
                this.update_options();
            },
            'slab': function (val, oldVal) {
                this.update_options();
            },
            'openingDirection': function (val, oldVal) {
                this.update_options();
            },
        },
    }
</script>
